import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { ORGANIZATION_TYPES } from 'src/app/modules/shared/constants/api-constants';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  private _loginapiUrl = `${environment.integration}/Authenticate`;

  constructor(
    private _http: HttpClient,
    private _router: Router,
  ) { }

  public loginRequest(loginForm: { email: string, password: string }): Observable<any> {

    const headers = new HttpHeaders({
      'OrganizationType': ORGANIZATION_TYPES.AGENT
    });
    return this._http.post(this._loginapiUrl, loginForm, { headers });
  }

  logoutUser(navigateToLogin: boolean = true) {
    const tempUserDetails = localStorage.getItem('userCredentials');
    localStorage.clear();
    if (tempUserDetails) {
      localStorage.setItem('userCredentials', tempUserDetails);
    }
    if(navigateToLogin){
      this._router.navigate(['/login']);
    }
  }

  resetPassword(){

  }
}